import { useState } from 'react'

const US_STATES = [
  { id: 1, name: 'Alabama', abbr: 'AL' },
  { id: 2, name: 'Alaska', abbr: 'AK' },
  { id: 3, name: 'Arizona', abbr: 'AZ' },
  { id: 4, name: 'Arkansas', abbr: 'AR' },
  { id: 5, name: 'California', abbr: 'CA' },
  { id: 6, name: 'Colorado', abbr: 'CO' },
  { id: 7, name: 'Connecticut', abbr: 'CT' },
  { id: 8, name: 'Delaware', abbr: 'DE' },
  { id: 9, name: 'Florida', abbr: 'FL' },
  { id: 10, name: 'Georgia', abbr: 'GA' },
  { id: 11, name: 'Hawaii', abbr: 'HI' },
  { id: 12, name: 'Idaho', abbr: 'ID' },
  { id: 13, name: 'Illinois', abbr: 'IL' },
  { id: 14, name: 'Indiana', abbr: 'IN' },
  { id: 15, name: 'Iowa', abbr: 'IA' },
  { id: 16, name: 'Kansas', abbr: 'KS' },
  { id: 17, name: 'Kentucky', abbr: 'KY' },
  { id: 18, name: 'Louisiana', abbr: 'LA' },
  { id: 19, name: 'Maine', abbr: 'ME' },
  { id: 20, name: 'Maryland', abbr: 'MD' },
  { id: 21, name: 'Massachusetts', abbr: 'MA' },
  { id: 22, name: 'Michigan', abbr: 'MI' },
  { id: 23, name: 'Minnesota', abbr: 'MN' },
  { id: 24, name: 'Mississippi', abbr: 'MS' },
  { id: 25, name: 'Missouri', abbr: 'MO' },
  { id: 26, name: 'Montana', abbr: 'MT' },
  { id: 27, name: 'Nebraska', abbr: 'NE' },
  { id: 28, name: 'Nevada', abbr: 'NV' },
  { id: 29, name: 'New Hampshire', abbr: 'NH' },
  { id: 30, name: 'New Jersey', abbr: 'NJ' },
  { id: 31, name: 'New Mexico', abbr: 'NM' },
  { id: 32, name: 'New York', abbr: 'NY' },
  { id: 33, name: 'North Carolina', abbr: 'NC' },
  { id: 34, name: 'North Dakota', abbr: 'ND' },
  { id: 35, name: 'Ohio', abbr: 'OH' },
  { id: 36, name: 'Oklahoma', abbr: 'OK' },
  { id: 37, name: 'Oregon', abbr: 'OR' },
  { id: 38, name: 'Pennsylvania', abbr: 'PA' },
  { id: 39, name: 'Rhode Island', abbr: 'RI' },
  { id: 40, name: 'South Carolina', abbr: 'SC' },
  { id: 41, name: 'South Dakota', abbr: 'SD' },
  { id: 42, name: 'Tennessee', abbr: 'TN' },
  { id: 43, name: 'Texas', abbr: 'TX' },
  { id: 44, name: 'Utah', abbr: 'UT' },
  { id: 45, name: 'Vermont', abbr: 'VT' },
  { id: 46, name: 'Virginia', abbr: 'VA' },
  { id: 47, name: 'Washington', abbr: 'WA' },
  { id: 48, name: 'West Virginia', abbr: 'WV' },
  { id: 49, name: 'Wisconsin', abbr: 'WI' },
  { id: 50, name: 'Wyoming', abbr: 'WY' },
]

export function USMap({ selectedState, onStateSelect, feedCounts = {} }) {
  const [hoveredState, setHoveredState] = useState(null)

  return (
    <div className="bg-white rounded-xl border border-gray-200 p-6">
      <h3 className="text-lg font-semibold mb-4">Select a State</h3>
      <p className="text-sm text-gray-600 mb-6">
        Click on a state to view and select feeds from that region
      </p>
      
      {/* Grid-based state selector */}
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-2 max-h-96 overflow-y-auto">
        {US_STATES.map((state) => {
          const count = feedCounts[state.id] || 0
          const isSelected = selectedState === state.name
          const isHovered = hoveredState === state.name
          
          return (
            <button
              key={state.id}
              onClick={() => onStateSelect(state.name)}
              onMouseEnter={() => setHoveredState(state.name)}
              onMouseLeave={() => setHoveredState(null)}
              className={`
                p-3 rounded-lg border-2 transition-all text-left
                ${isSelected 
                  ? 'border-primary bg-slate-50 text-slate-900' 
                  : isHovered
                  ? 'border-slate-300 bg-slate-50'
                  : 'border-gray-200 hover:border-gray-300'
                }
                ${count === 0 ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}
              `}
              disabled={count === 0}
            >
              <div className="font-semibold text-sm">{state.abbr}</div>
              <div className="text-xs text-gray-600 mt-1">
                {count} {count === 1 ? 'feed' : 'feeds'}
              </div>
            </button>
          )
        })}
      </div>
      
      {selectedState && (
        <div className="mt-4 p-3 bg-slate-50 rounded-lg border border-slate-200">
          <p className="text-sm font-medium text-slate-900">
            Selected: {selectedState}
          </p>
        </div>
      )}
    </div>
  )
}

export { US_STATES }
